package app.nestbridge.ui.theme

import androidx.compose.runtime.Composable
import com.karawek.core.ui.theme.*

// CoreLightColorScheme / CoreDarkColorScheme already carry the NestBridge brand
// colors derived from the Claude Design system. We use them directly.
val NestBridgeLightColorScheme = CoreLightColorScheme
val NestBridgeDarkColorScheme = CoreDarkColorScheme

@Composable
fun NestBridgeTheme(
    themeMode: ThemeMode = ThemeMode.System,
    content: @Composable () -> Unit,
) {
    CoreTheme(
        lightColors = NestBridgeLightColorScheme,
        darkColors = NestBridgeDarkColorScheme,
        themeMode = themeMode,
        content = content,
    )
}
